/**
 * PNG 書き出し（spec §9.1 / FR-18 / FR-19）。
 *
 * 現フレームの canvas を PNG Blob 化してダウンロードする単発処理。現在の
 * 画面表示をそのまま書き出すため、呼び出し側は **事前に `render(ctx, state)`
 * を済ませておく**（本モジュールは再描画を行わない）。
 *
 * 解像度は内部解像度（`canvas.width/height`）そのまま。alpha 保持（PNG）。
 *
 * 設計参照:
 * - docs/happa-designtool.md §9.1（PNG 出力）
 * - `state.backgroundTransparent === true` のとき、renderer は `clearRect` で
 *   背景を抜いているので PNG 出力も透明が保たれる。
 */

/**
 * 現在の canvas 内容を PNG として `download` させる。
 *
 * 同期処理（`toDataURL` は blocking）。失敗しても throw せず `console.error`
 * のみに留める（UI を固めない）。
 *
 * ファイル名は `happa-<unix-ms>.png`。秒精度ではなく ms にしておくと、連打
 * しても衝突しない。
 *
 * @param canvas 対象の `HTMLCanvasElement`（`ctx.canvas`）。
 */
export function exportPng(canvas: HTMLCanvasElement): void {
  try {
    const dataUrl = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.download = `happa-${Date.now()}.png`;
    link.href = dataUrl;
    // DOM に append する必要はないが、Safari 旧バージョンで `click()` が
    // 無視されるケースがあるので念のため body に一時追加して click → remove。
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    // Canvas が tainted（CORS 汚染）な場合のみ起きる。happa は外部画像を
    // 読まないので実運用では発生しないが、念のためログを残す。
    console.error('[export/png] PNG export failed:', err);
  }
}
